"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = exports.PaginationItem = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Pagination = styled_components_1.default.div `
    display: flex;
    justify-content: center;
    gap: 6px;
`;
exports.Pagination = Pagination;
const PaginationItem = styled_components_1.default.span `
    background: #AEBBD2CF;
    width: 24px;
    height: 11px;
    border-radius: 35px;
    background: ${(props) => props.active ? props.active : "#AEBBD2CF"};
    border: ${(props) => props.active ? "3px solid #fff" : 0};
    @media (max-width: 768px) {
        width: 18px;
    }
    @media (max-width: 500px) {
        width: 14px;
    }
`;
exports.PaginationItem = PaginationItem;
